import Logo from "../../../assets/images/Logo-echoed.svg";

export const Payment = ({ setStep }) => (
  <>
    <img src={Logo} alt="logo" width={120} className="pointer p-b-20" />
    <div className="auth-form payment">
      <div className="auth-items">
        <div className="flex">
          <span className="bold font-16"> Small Teams </span>
          <span className="bold font-16 p-l-35">
            $999<span className="normal">/mo</span>
          </span>
        </div>
        <div className="space-between">
          <div className="w-30p flex-col">
            <div className="p-b-5 font-10">Credit Card Number</div>
            <input type="text" className="w-100p" />
            <span className="auth-input-error">First name and Last name are required</span>
          </div>
          <div className="w-30p flex-col">
            <div className="p-b-5 font-10">Name on Card</div>
            <input type="text" className="w-100p" />
            <span className="auth-input-error">First name and Last name are required</span>
          </div>
          <div className="w-30p flex">
            <div>
              <div className="p-b-5 font-10">Exp (MM/YY)</div>
              <input type="text" className="w-100p" />
              <span className="auth-input-error">Last name</span>
            </div>
            <div className="p-l-15">
              <div className="p-b-5 font-10">CVV</div>
              <input type="text" />
              <span className="auth-input-error">First name</span>
            </div>
          </div>
        </div>
        <div className="flex-col">
          <span className="bold font-16 p-b-20"> Billing Address</span>
          <div className="space-between">
            <div className="w-25p flex-col">
              <div className="p-b-5 font-10">Credit Card Number</div>
              <input type="text" className="w-100p" />
              <span className="auth-input-error">First name and Last name are required</span>
            </div>
            <div className="w-30p flex-col">
              <div className="p-b-5 font-10">Name on Card</div>
              <input type="text" className="w-100p" />
              <span className="auth-input-error">First name and Last name are required</span>
            </div>
            <div className="w-35p flex">
              <div>
                <div className="p-b-5 font-10">City</div>
                <input type="text" className="w-100p" />
                <span className="auth-input-error">Last name</span>
              </div>
              <div className="p-l-15">
                <div className="p-b-5 font-10">State</div>
                <input type="text" />
                <span className="auth-input-error">First name</span>
              </div>
              <div className="p-l-15">
                <div className="p-b-5 font-10">Zip</div>
                <input type="text" />
                <span className="auth-input-error">First name</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-end align-items-center p-t-20">
          <span className="text-blue pointer bold p-r-10" onClick={() => setStep("choose-plan")}>
            Back
          </span>
          <div className="btn-full w-290" onClick={() => setStep("payment")}>
            Request Trial
          </div>
        </div>
      </div>
    </div>
  </>
);
